module.exports = __webpack_public_path__ + "img/hunters_hall_small.0606ace3.png";